<template>
  <v-checkbox
    v-model="checked"
    class="LinkBucket"
    :color="checkboxColor"
    hide-details
  >
    <template #label>
      <v-div d-inline :foreground="labelColor">
        <span>{{ bucket.label }}</span>
        <v-div
          v-if="bucket.count"
          d-inline
          caption
          font-small
          pr-2
          pl-2
          :foreground="labelColor"
          >({{ bucket.count }})</v-div
        >
      </v-div>
    </template>
    <v-div slot="append">
      <a
        v-if="showLink"
        :href="`/engage/${bucket.key.toLowerCase()}/search-dashboard`"
        class="no-underline"
        :aria-label="`go to ${bucket.label} [opens in a new tab]`"
        target="_blank"
        rel="noopener"
      >
        <v-icon small color="primary" aria-hidden="true">{{
          mdiOpenInNew
        }}</v-icon>
      </a>
    </v-div>
  </v-checkbox>
</template>

<script>
import { mdiOpenInNew } from "@mdi/js";
import { mapState } from "vuex";

export default {
  name: "LinkBucket",
  props: {
    bucket: { type: Object, required: true },
    selected: { type: Array, default: () => [] },
  },
  data() {
    return {
      mdiOpenInNew,
    };
  },
  computed: {
    ...mapState({
      layout: (state) => state.theme.layout,
    }),
    labelColor() {
      return this.layout.linkBucketLabelColor;
    },
    checkboxColor() {
      return this.layout.linkBucketCheckboxColor;
    },
    checked: {
      get() {
        const match = this.bucket.key;
        const list = this.selected;
        const matched = list.find((id) => id === match);
        const checked = matched !== undefined;

        return this.bucket.checked || checked;
      },
      set(newValue) {
        this.$emit("selectionChanged", {
          id: this.bucket.key,
          value: newValue,
        });
      },
    },
    showLink() {
      return this.bucket.key.toLowerCase() !== this.$config.partner;
    },
  },
};
</script>
